/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

/** @jsxImportSource @emotion/react */
import { FC } from "react";
import { css, keyframes } from "@emotion/react";

const load5 = keyframes`
    0%,
    100% {
      box-shadow: 0em -2.6em 0em 0em #8ba0c1,
        1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2),
        2.5em 0em 0 0em rgba(139, 160, 193, 0.2),
        1.75em 1.75em 0 0em rgba(139, 160, 193, 0.2),
        0em 2.5em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em 1.8em 0 0em rgba(139, 160, 193, 0.2),
        -2.6em 0em 0 0em rgba(139, 160, 193, 0.5),
        -1.8em -1.8em 0 0em rgba(139, 160, 193, 0.7);
    }
    12.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(139, 160, 193, 0.7),
        1.8em -1.8em 0 0em #8ba0c1, 2.5em 0em 0 0em rgba(139, 160, 193, 0.2),
        1.75em 1.75em 0 0em rgba(139, 160, 193, 0.2),
        0em 2.5em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em 1.8em 0 0em rgba(139, 160, 193, 0.2),
        -2.6em 0em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em -1.8em 0 0em rgba(139, 160, 193, 0.5);
    }
    25% {
      box-shadow: 0em -2.6em 0em 0em rgba(139, 160, 193, 0.5),
        1.8em -1.8em 0 0em rgba(139, 160, 193, 0.7), 2.5em 0em 0 0em #8ba0c1,
        1.75em 1.75em 0 0em rgba(139, 160, 193, 0.2),
        0em 2.5em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em 1.8em 0 0em rgba(139, 160, 193, 0.2),
        -2.6em 0em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2);
    }
    37.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(139, 160, 193, 0.2),
        1.8em -1.8em 0 0em rgba(139, 160, 193, 0.5),
        2.5em 0em 0 0em rgba(139, 160, 193, 0.7), 1.75em 1.75em 0 0em #8ba0c1,
        0em 2.5em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em 1.8em 0 0em rgba(139, 160, 193, 0.2),
        -2.6em 0em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2);
    }
    50% {
      box-shadow: 0em -2.6em 0em 0em rgba(139, 160, 193, 0.2),
        1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2),
        2.5em 0em 0 0em rgba(139, 160, 193, 0.5),
        1.75em 1.75em 0 0em rgba(139, 160, 193, 0.7), 0em 2.5em 0 0em #8ba0c1,
        -1.8em 1.8em 0 0em rgba(139, 160, 193, 0.2),
        -2.6em 0em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2);
    }
    62.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(139, 160, 193, 0.2),
        1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2),
        2.5em 0em 0 0em rgba(139, 160, 193, 0.2),
        1.75em 1.75em 0 0em rgba(139, 160, 193, 0.5),
        0em 2.5em 0 0em rgba(139, 160, 193, 0.7), -1.8em 1.8em 0 0em #8ba0c1,
        -2.6em 0em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2);
    }
    75% {
      box-shadow: 0em -2.6em 0em 0em rgba(139, 160, 193, 0.2),
        1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2),
        2.5em 0em 0 0em rgba(139, 160, 193, 0.2),
        1.75em 1.75em 0 0em rgba(139, 160, 193, 0.2),
        0em 2.5em 0 0em rgba(139, 160, 193, 0.5),
        -1.8em 1.8em 0 0em rgba(139, 160, 193, 0.7), -2.6em 0em 0 0em #8ba0c1,
        -1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2);
    }
    87.5% {
      box-shadow: 0em -2.6em 0em 0em rgba(139, 160, 193, 0.2),
        1.8em -1.8em 0 0em rgba(139, 160, 193, 0.2),
        2.5em 0em 0 0em rgba(139, 160, 193, 0.2),
        1.75em 1.75em 0 0em rgba(139, 160, 193, 0.2),
        0em 2.5em 0 0em rgba(139, 160, 193, 0.2),
        -1.8em 1.8em 0 0em rgba(139, 160, 193, 0.5),
        -2.6em 0em 0 0em rgba(139, 160, 193, 0.7), -1.8em -1.8em 0 0em #8ba0c1;
    }
`;

const loader = css`
  margin: 40px auto 20px auto;
  font-size: 10px;
  width: 1.4em;
  height: 1.4em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: ${load5} 1.1s infinite ease;
  transform: translateZ(0);
`;

export const Spinner: FC = () => {
  return <div css={loader} />;
};
